var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    clipPath: "url(#clip0_1161_120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1666 10.1567V11C20.1655 12.9768 19.5254 14.9002 18.3418 16.4834C17.1582 18.0666 15.4946 19.2248 13.599 19.7853C11.7034 20.3457 9.67741 20.2784 7.82318 19.5934C5.96896 18.9084 4.38585 17.6423 3.30997 15.984C2.23408 14.3257 1.72306 12.3641 1.85312 10.3917C1.98318 8.41922 2.74736 6.54167 4.03167 5.03902C5.31599 3.53637 7.05164 2.48914 8.97976 2.05351C10.9079 1.61787 12.9252 1.81718 14.7308 2.62171",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1667 3.6665L11 12.8423L8.25 10.0923",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.53bf9541eae116405bc9a6e25910aec9.svg";
export { ForwardRef as ReactComponent };